import React from 'react';

export interface LeadBadgeProps {
  status: string;
}

export default function LeadBadge({ status }: LeadBadgeProps): React.JSX.Element {
  const map: Record<string, { bg: string; color: string }> = {
    hot:  { bg: "rgba(255,77,106,0.12)",  color: "#FF4D6A" },
    warm: { bg: "rgba(255,181,71,0.12)",  color: "#FFB547" },
    cold: { bg: "rgba(77,166,255,0.12)",  color: "#4DA6FF" },
  };
  const s = map[status] ?? map.cold;
  return (
    <span
      className="text-[10px] font-semibold px-2 py-0.5 rounded-[10px] uppercase tracking-[0.5px]"
      style={{ background: s.bg, color: s.color }}
    >
      {status}
    </span>
  );
}
